import { FC, useState } from 'react';
import { NumberUtils, Tr } from '@utils';
import { SimulationKPI } from '@services';
import { Card, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { DarkCard, IDarkCardProps } from '@components/common';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import LockIcon from '@mui/icons-material/Lock';

const CARD_COUNT = 5;
const SummaryCard: FC<IDarkCardProps> = (props) => {
	return (
		<DarkCard
			sx={{ flexGrow: 1, height: 1.0, paddingX: 4, paddingBottom: 2, paddingTop: 3 }}
			iconContentSpacing={0.5}
			titleProps={{ variant: 'body1' }}
			subtitleProps={{ variant: 'body2' }}
			{...props}
		/>
	);
};

export interface ILocationInfrastructureSizingKPIsProps {
	kpi?: SimulationKPI;
}

export const LocationInfrastructureSizingKPIs: FC<ILocationInfrastructureSizingKPIsProps> = ({ kpi }) => {
	const [selectedYear, setSelectedYear] = useState(10);
	const isProd = window.location.host === 'app.voltaage.io';

	return (
		<Stack direction="column" spacing={2}>
			<Grid container direction="row" columnSpacing={4}>
				<Grid item xs={12} lg={12 / CARD_COUNT}>
					<SummaryCard
						pattern="circlepattern1"
						icon={
							<Stack direction="row" alignItems="center" spacing={2}>
								{isProd ? (
									<>
										<Tooltip
											title={<Tr.Portal path="location.site-infra.coming-soon" />}
											arrow
											placement="bottom"
											componentsProps={{ tooltip: { sx: { padding: 1 } } }}
										>
											<LockIcon color="inherit" />
										</Tooltip>
										{/* <Typography variant="h3">
											{NumberUtils.formatAsNumber(kpi?.breakEvenDurationInYears, { decimalScale: 1 })}
										</Typography> */}
									</>
								) : null}
							</Stack>
						}
						title={<Tr.Portal path="location.site-infra.breakeven-card-title" />}
						subtitle={<Tr.Portal path="location.site-infra.breakeven-card-subtitle" />}
					/>
				</Grid>
				<Grid item xs={12} lg={12 / CARD_COUNT}>
					<SummaryCard
						pattern="circlepattern3"
						icon={
							<Stack direction="row" alignItems="center" spacing={2}>
								{isProd ? (
									<>
										<Tooltip
											title={<Tr.Portal path="location.site-infra.coming-soon" />}
											arrow
											placement="bottom"
											componentsProps={{ tooltip: { sx: { padding: 1 } } }}
										>
											<LockIcon color="inherit" />
										</Tooltip>
										{/* <Typography variant="h3">
											{NumberUtils.formatAsNumber((kpi?.returnOnInvestment || 0) * 100 * selectedYear, {
												decimalScale: 0
											})}
										</Typography> */}
									</>
								) : null}
							</Stack>
						}
						title={<Tr.Portal path="location.site-infra.roi-card-title" />}
						subtitle={<Tr.Portal path="location.site-infra.roi-card-subtitle" />}
					/>
				</Grid>
				<Grid item xs={12} lg={12 / CARD_COUNT}>
					<SummaryCard
						pattern="circlepattern2"
						icon={
							<Typography variant="h3">
								{NumberUtils.formatAsNumber((kpi?.co2ReductionTotal || 0) * selectedYear, { decimalScale: 0 })}
							</Typography>
						}
						title={<Tr.Portal path="location.site-infra.co2-reduction-card-title" />}
						subtitle={<Tr.Portal path="location.site-infra.co2-reduction-card-subtitle" />}
					/>
				</Grid>
				<Grid item xs={12} lg={12 / CARD_COUNT}>
					<SummaryCard
						pattern="circlepattern1"
						icon={
							<Typography variant="h3">
								{NumberUtils.formatAsNumber((kpi?.treesSaved || 0) * selectedYear, { decimalScale: 0 })}
							</Typography>
						}
						title={<Tr.Portal path="location.site-infra.trees-card-title" />}
						subtitle={<Tr.Portal path="location.site-infra.trees-card-subtitle" />}
					/>
				</Grid>
				<Grid item xs={12} lg={12 / CARD_COUNT}>
					<SummaryCard
						pattern="circlepattern3"
						icon={
							<Typography variant="h3">
								{NumberUtils.formatAsNumber(kpi?.chargingPointsToInstall, { decimalScale: 0 })}
							</Typography>
						}
						title={<Tr.Portal path="location.site-infra.charging-points-card-title" />}
						subtitle={<Tr.Portal path="location.site-infra.charging-points-card-subtitle" />}
					/>
				</Grid>
			</Grid>

			<Card sx={{ width: 1.0, paddingX: 2, paddingY: 1 }} variant="outlined">
				<Stack direction="row" alignItems="center">
					<Typography sx={{ marginRight: 4 }}>
						<Tr.Portal withInsecureTemplating path="location.site-infra.calculated-over-year" options={{ selectedYear }} />
					</Typography>
					<IconButton onClick={() => setSelectedYear(Math.max(1, selectedYear - 1))}>
						<RemoveCircleOutlineIcon color="inherit" />
					</IconButton>
					<IconButton onClick={() => setSelectedYear(selectedYear + 1)}>
						<ControlPointIcon color="inherit" />
					</IconButton>
				</Stack>
			</Card>
		</Stack>
	);
};
